<template>
  <main class="pricing">
    <!-- Hero -->
    <section>
      <header class="pricing__hero mt-6 mt-md-0">
        <v-container>
          <v-row justify="center">
            <v-col md="8">
              <h1 class="pricing__hero-title">
                Contrata profesionales más comprometidos
              </h1> 
              <p class="pricing__hero-text">
                Somos líderes en conectar talentos con ONGs, Empresas B, Startups y Emprendimientos
                con propósito.
              </p>
              <v-btn
                href="#prices"
                class="pricing__hero-btn my-4"
                elevation="0"
                small
              >
                VER PLANES
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </header>
    </section>

    <!-- Content -->
    <section>
      <!-- #prices Anchor -->
      <div id="prices" class="d-hidden"></div>

      <!-- Prices -->
      <article class="pricing__section pricing__prices">
        <v-container>
          <v-row justify="center">
            <v-col cols="12">
              <h2 class="pricing__title d-md-none">Planes y precios</h2>
              <p class="pricing__subtitle d-md-none">¡Compra packs y ahorra hasta un 50%!</p>
              <Prices class="d-md-none" context="pricing" />

              <v-card class="pa-4 d-none d-md-block" rounded="xl">
                <h2 class="pricing__title d-none d-md-block">
                  Planes y precios
                </h2>
                <p class="pricing__subtitle d-none d-md-block">
                  ¡Compra packs y ahorra hasta un 50%!
                </p>
                <Prices context="pricing" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </article>

      <!-- Organization size -->
      <article class="pricing__section pricing__sizes pb-2">
        <v-container>
          <v-row justify="center" justify-md="start">
            <v-col cols="12" md="7">
              <v-img
                class="pricing__sizes-img d-md-none"
                :src="require('@/assets/images/soy-organizacion_banner_2.webp')"
                position="center center"
              />

              <h2 class="pricing__title pricing__title--white">Planes para todos</h2>
              <p class="pricing__text mt-2 mt-md-0">
                No importa el tamaño de tu organización, para cumplir tu propósito necesitas los
                mejores talentos. Tenemos precios especiales para distintas necesidades.
              </p>

              <!-- Small Organizations -->
              <v-card class="size-card">
                <v-container>
                  <v-row align="center">
                    <v-col cols="12" md="5">
                      <h3 class="size-card__title">Pequeñas Organizaciones</h3>
                    </v-col>
                    <v-col cols="12" md="7">
                      <p class="size-card__text">
                        Si estás recién partiendo o tu organización aún es pequeña, contáctanos,
                        tenemos planes con precios especiales para tu necesidad.
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <!-- Big Organizations -->
              <v-card class="size-card">
                <v-container>
                  <v-row align="center">
                    <v-col cols="12" md="5">
                      <h3 class="size-card__title">Grandes Organizaciones</h3>
                    </v-col>
                    <v-col cols="12" md="7">
                      <p class="size-card__text">
                        ¿Necesitas más de 10 publicaciones?
                      </p>
                      <p class="size-card__text">
                        Contáctate con nosotros para entregarte un servicio a tu medida.
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>

              <v-btn
                class="pricing__sizes-btn"
                href="mailto:nmorales@trabajoconsentido.com?subject=Planes y precios"
                target="_blank"
                elevation="0"
                large
              >
                CONVERSEMOS
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </article>

      <!-- Steps -->
      <article class="pricing__section pricing__steps">
        <v-container>
          <v-row justify="center">
            <v-col md="12">
              <h2 class="pricing__title">Pasos para publicar</h2>
              <p class="pricing__text">
                ¿Ya contrataste tu plan? ¡Comienza a recibir candidatos en solo 3 pasos!
              </p>
            </v-col>
          </v-row>

          <!-- Step cards -->
          <v-row justify="center">
            <v-col
              v-for="(step, index) in steps"
              :key="index"
              cols="12"
              md="3"
              class="ma-0 mb-6 mb-md-0 pa-0 d-flex justify-center"
            >
              <StepCard :icon="step.icon">
                {{ step.title }}
                <template v-if="step.disclaimer" #disclaimer>
                  {{ step.disclaimer }}
                </template>
              </StepCard>
            </v-col>
          </v-row>
        </v-container>
      </article>

      <!-- ATS -->
      <article class="pricing__section pricing__ats">
        <v-container>
          <v-row justify="center" align="center">
            <v-col md="6" order-md="last">
              <h2 class="pricing__title d-md-none">ATS</h2>
              <p class="pricing__text d-md-none">
                Administra tu proceso de reclutamiento fácilmente sin costo adicional
              </p>
              <v-img :src="require('@/assets/images/ats.webp')" />
              <v-btn
                text
                color="#3abdff"
                @click="toggleSection('ats')"
                retain-focus-on-click
                large
                plain
                depressed
              >
                <v-col class="d-flex d-md-none flex-column align-center show-more">
                  <strong>{{ expandSection.ats ? "OCULTAR" : "VER MÁS" }}</strong>
                  <v-icon color="">mdi-chevron-{{ expandSection.ats ? "up" : "down" }}</v-icon>
                </v-col>
              </v-btn>
            </v-col>

            <v-col class="text-md-left" md="6">
              <h2 class="pricing__title d-none d-md-block">ATS</h2>
              <p class="pricing__text d-none d-md-block">
                Administra tu proceso de reclutamiento fácilmente sin costo adicional
              </p>

              <v-expand-transition>
                <div v-show="expandSection.ats || isDesktop">
                  <p class="pricing__text2">
                    Una vez publicada la oferta en nuestra comunidad, <strong>los 200.000+ profesionales
                    podrán revisarla, conocer tu organización y postular</strong>. Tú los recibirás
                    cómodamente en nuestro ATS (Applicant Tracking System) donde <strong>podrás
                    visualizar y gestionar el proceso de reclutamiento completo</strong> de manera
                    <strong>simple e intuitiva</strong>. Simplemente mueve a un candidato de un estado
                    a otro.
                  </p>
                  <p class="pricing__text2">
                    <strong>¡Comienza a buscar candidatos!</strong>
                  </p>
                </div>
              </v-expand-transition>

              <v-btn
                class="pricing__btn d-md-none"
                href="#prices"
                active-class="pricing__btn--active"
                elevation="0"
              >
                VER PLANES
              </v-btn>
              <v-btn
                class="pricing__btn d-none d-md-flex"
                href="#prices"
                active-class="pricing__btn--active"
                elevation="0"
                outlined
              >
                VER PLANES
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </article>

      <!-- Organization Profile -->
      <article class="pricing__section pricing__profile">
        <v-container>
          <v-row align="center">
            <v-col md="12">
              <h2 class="pricing__title">Perfil de organización</h2>
              <p class="pricing__text">
                Da a conocer tu organización, tú propósito y mucho más a nuestra comunidad
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <v-img
                class="pricing__profile-image"
                :src="require('@/assets/images/organizaciones.webp')"
              />
              <v-btn
                text
                color="#3abdff"
                @click="toggleSection('profile')"
                retain-focus-on-click
                large
                plain
                depressed
              >
                <v-col class="d-flex d-md-none flex-column align-center show-more">
                  <strong>{{ expandSection.profile ? "OCULTAR" : "VER MÁS" }}</strong>
                  <v-icon color="">mdi-chevron-{{ expandSection.profile ? "up" : "down" }}</v-icon>
                </v-col>
              </v-btn>
            </v-col>
            <v-col class="text-md-left" md="6">
              <v-expand-transition>
                <div v-show="expandSection.profile || isDesktop">
                  <p class="pricing__text2">
                    ¿Sabías que las organizaciones con fuerte sentido de propósito tienen <strong>3
                    veces más probabilidades</strong> de sumar a sus equipos a talentos de alto
                    desempeño? [Tendencias Globales Talentos, Mercer]. Cuando publiques en Trabajo con
                    Sentido <strong>te haces parte de nuestra comunidad</strong> de organizaciones de
                    impacto y profesionales que <strong>priorizan su búsqueda en el propósito</strong>.
                  </p>
                  <p class="pricing__text2">
                    ¡Crea tu perfil de organización <strong>(sin costo)</strong> y hazla visible para
                    toda la comunidad!
                  </p>
                </div>
              </v-expand-transition>
              <v-btn
                class="pricing__btn mb-4 mt-md-4"
                href="#prices"
                active-class="pricing__btn--active"
                outlined
              >
                VER PLANES
              </v-btn>
              <p class="pricing__disclaimer d-none d-md-block">
                *Sujeto a moderación
              </p>
            </v-col>
          </v-row>
        </v-container>
      </article>

      <!-- Other services -->
      <article class="pricing__section pricing__other">
        <v-container>
          <v-row align="center">
            <v-col class="d-md-none" cols="12">
              <h2 class="pricing__title mb-4">Otros servicios</h2>
            </v-col>
            <v-col order-md="first" md="6">
              <v-img :src="require('@/assets/images/otros_servicios.webp')" />
            </v-col>
            <v-col md="6">
              <h2 class="pricing__title mb-4 d-none d-md-block">Otros servicios</h2>
              <p class="pricing__text2">
                Necesitas servicios de Consultoría, Selección, Evaluaciones Psicolaborales
                impulsadas desde el propósito? Conoce los servicios de la consultora
                <strong>Talento con Sentido</strong> (serás redirigido a su sitio web).
              </p>
              <v-btn
                class="pricing__other-btn"
                href="https://www.talentoconsentido.cl/services"
                target="_blank"
                active-class="pricing__btn--active"
                outlined
              >
                VER MÁS
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </article>

      <!-- Contact -->
      <article class="pricing__section pricing__contact d-none d-sm-block">
        <v-container>
          <v-row>
            <v-col>
              <h2 class="pricing__title pricing__title--white">CONSULTAS / DUDAS</h2>
              <p class="pricing__text">
                Si tienes consultas o dudas, ¡contáctanos! Felices de ayudarte.
              </p>
              <v-btn
                href="mailto:hola@trabajoconsentido.com?subject=Consulta"
                target="_blank"
                class="pricing__contact-btn mt-4"
                x-large
                outlined
              >CONTÁCTANOS</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </article>
    </section>
  </main>
</template>

<script>
import StepCard from "@/components/StepCard";
import Prices from "@/components/Prices";
import { meta } from "@/libs/mixins";

export default {
    name: "Pricing",

    components: {
        StepCard,
        Prices,
    },

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Planes y precios",
        });
    }, 

    data() {
        return {
            expandSection: {
                ats: false,
                profile: false,
            },
            steps: [
                {
                    icon: "perfil",
                    title: "CREA TU PERFIL",
                },
                {
                    icon: "oferta",
                    title: "CREA TU OFERTA",
                    disclaimer: "* Con proceso de moderación",
                },
                {
                    icon: "postulantes",
                    title: "RECIBE POSTULANTES",
                },
            ],
        };
    },

    computed: {
        isDesktop() {
            return this.$vuetify.breakpoint.mdAndUp;
        }
    },

    methods: {
        toggleSection(section) {
            this.expandSection[section] = !this.expandSection[section];
        },
    },
};
</script>
